import { createSlice } from '@reduxjs/toolkit'
import axios from '../../api/index'
import { failed } from './snackSlice'

export const commentSlice = createSlice({
  name: 'commnets',
  initialState: [],
  reducers: {
    commentsFetched: (state, { payload }) => payload,
    clearComments: () => [],
  },
})

export const {
  commentsFetched,
  clearComments,
} = commentSlice.actions

export const deleteComments = () => (dispatch) => {
  dispatch(clearComments())
}

export const getComments = (ticketId) => (dispatch) => {
  axios.get(`ticket/${ticketId}/comments`)
    .then((res) => {
      dispatch(commentsFetched(res?.data.data))
      if (console.save) console.save(res?.data.data)
    })
    .catch((e) => {
      dispatch(failed(e?.response?.data?.message, ''))
      dispatch(failed('مشکل در دریافت پیام‌ها'))
    })
}

export default commentSlice.reducer
